export default __webpack_public_path__ + "static/media/Q6-2.731fe3da.jpg";